import type { QuoteDocument } from 'paintscout'
import { parseNumber } from '../util/parse-number'

export function calculateAfterTax(quote: QuoteDocument) {
  const price = parseNumber(quote.totals.after_discount)
  const totalTax = parseNumber(quote.totals.total_tax)

  return price + totalTax
}
